export const getRemainingAmount = (totalAmount, spendingAmount) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });

  if (spendingAmount > totalAmount) {
    return formatter.format(0);
  }
  return formatter.format(totalAmount - spendingAmount);
};

export const getPercentage = (totalAmount, spendingAmount) => {
  if (spendingAmount > totalAmount) {
    return 100;
  }
  return Math.floor((spendingAmount / totalAmount) * 100);
};
